import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=483740bd&scoped=true&"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsModal.vue?vue&type=style&index=0&id=483740bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483740bd",
  null
  
)

export default component.exports